import * as Sentry from "@sentry/vue";
import { Module } from "vuex";
import { SET_USER, SIGN_OUT } from "../action-types";
import User from "../../entities/User";
import EventBus from "../../utils/EventBus";
import UsersRepository from "../../repositories/implementations/UsersRepository";

class State {
  user: null | User = null;
}

const authModule: Module<State, any> = {
  namespaced: true,

  state: {
    user: null,
  },

  getters: {
    user(state: State) {
      return state.user;
    },
  },

  mutations: {
    [SET_USER](theState: State, user: null | User) {
      theState.user = user;
    },
  },

  actions: {
    [SET_USER]({ state, commit }, user: null | User) {
      const oldUser = state.user;
      const userIdHasChanged = oldUser?.id !== user?.id;

      const userData = { id: user?.id, email: user?.email };
      localStorage.setItem("parlaeditor_user", user ? JSON.stringify(userData) : "");
      commit(SET_USER, user);

      Sentry.setUser({ id: user?.id as string });

      if (userIdHasChanged) {
        EventBus.$emit("local-user-changed", { newUser: user });
      }
    },
    async [SIGN_OUT]({ dispatch }) {
      await dispatch(SET_USER, null);

      const usersRepository = new UsersRepository();
      await usersRepository.signOut();
    },
  },
};

export default authModule;
